var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _g4, _path14, _g5, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 15,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.748047 7.85547H14.123V15.1055H0.748047V7.85547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1602_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.47168L6.11523 14.8662L14.0518 13.3857L8.68652 7.99121L0.75 9.47168Z",
    fill: "#7FC94C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13867 14.8613L7.29102 16.0195L15.2031 14.5439L14.0508 13.3857L6.13867 14.8613Z",
    fill: "#F9F792"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 14,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12305 14.3555H20.623V21.4316H7.12305V14.3555Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1602_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26855 16.0254L12.6455 21.4326L20.583 19.9531L15.2051 14.5459L7.26855 16.0254Z",
    fill: "#4CA0C9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 7.99121L14.0215 13.3857L24.6397 14.6016L19.2744 9.20703L8.65625 7.99121Z",
    fill: "#7FC94C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0215 13.3857L15.1738 14.5439L18.9561 14.9766L24.334 20.3838L27.4199 20.7373L22.042 15.3301L25.791 15.7598L24.6387 14.6006L14.0215 13.3857Z",
    fill: "#F9F792"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0449 15.332L27.4229 20.7393L31.1719 21.168L25.7939 15.7617L22.0449 15.332Z",
    fill: "#C9A14C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1748 14.5459L20.5527 19.9521L24.335 20.3857L18.958 14.9785L15.1748 14.5459Z",
    fill: "#4CA0C9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 13,
    width: 14,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.623 13.3555H38.248V21.3555H25.623V13.3555Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1602_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6475 15.7627L31.0254 21.1699L38.2441 18.9678L32.8662 13.5605L25.6475 15.7627Z",
    fill: "#C9A14C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1289 9.20898L24.4941 14.6035L31.7129 12.4014L26.3477 7.00586L19.1289 9.20898Z",
    fill: "#7FC94C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4941 14.6025L25.6465 15.7617L32.8643 13.5596L31.7119 12.4004L24.4941 14.6025Z",
    fill: "#F9F792"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67578 8L14.0264 13.3926L15.1924 14.5605L20.543 19.9531L24.3506 20.3994L27.4385 20.7432L31.1768 21.1553L25.792 15.7627L24.6602 14.5947L19.2744 9.20215L8.67578 8Z",
    fill: "black",
    fillOpacity: 0.152
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 11,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.873 0.105469H26.123V15.1055H16.873V0.105469Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1602_5662)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 10,
    height: 15
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.998 4.67578C25.998 7.18457 21.4609 13.0664 21.4609 14.8799C21.4609 13.0674 16.9248 7.18457 16.9248 4.67578C16.9248 2.16602 18.9561 0.132812 21.4609 0.132812C23.9668 0.132812 25.998 2.16602 25.998 4.67578Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1602_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9248 0.132812V14.8799H25.998V0.132812H16.9248Z",
    fill: "url(#paint0_linear_1602_5662)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1602_5662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 11,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.623 0.0566406H26.123V15.1055H16.623V0.0566406Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1602_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.998 4.67578C25.998 7.18457 21.4609 13.0664 21.4609 14.8799C21.4609 13.0674 16.9248 7.18457 16.9248 4.67578C16.9248 2.16601 18.956 0.132812 21.4609 0.132812C23.9668 0.132812 25.998 2.16601 25.998 4.67578Z",
    stroke: "#A00000",
    strokeWidth: 0.150698,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0215 4.58203C23.0215 4.68457 23.0117 4.78613 22.9912 4.88672C22.9717 4.9873 22.9424 5.08496 22.9023 5.17969C22.8633 5.27441 22.8154 5.36426 22.7588 5.4502C22.7021 5.53516 22.6367 5.61426 22.5645 5.68652C22.4922 5.75879 22.4131 5.82422 22.3281 5.88086C22.2432 5.9375 22.1533 5.98633 22.0586 6.02539C21.9639 6.06445 21.8662 6.09375 21.7656 6.11426C21.665 6.13379 21.5645 6.14356 21.4619 6.14356C21.3594 6.14356 21.2578 6.13379 21.1572 6.11426C21.0566 6.09375 20.959 6.06445 20.8643 6.02539C20.7705 5.98633 20.6807 5.9375 20.5947 5.88086C20.5098 5.82422 20.4307 5.75879 20.3584 5.68652C20.2861 5.61426 20.2217 5.53516 20.165 5.4502C20.1074 5.36426 20.0596 5.27441 20.0205 5.17969C19.9814 5.08496 19.9521 4.9873 19.9316 4.88672C19.9121 4.78613 19.9014 4.68457 19.9014 4.58203C19.9014 4.47949 19.9121 4.37793 19.9316 4.27734C19.9521 4.17676 19.9814 4.0791 20.0205 3.98438C20.0596 3.88965 20.1074 3.7998 20.165 3.71387C20.2217 3.62891 20.2861 3.5498 20.3584 3.47754C20.4307 3.40527 20.5098 3.33984 20.5947 3.2832C20.6807 3.22656 20.7705 3.17773 20.8643 3.13867C20.959 3.09961 21.0566 3.07031 21.1572 3.0498C21.2578 3.03027 21.3594 3.02051 21.4619 3.02051C21.5645 3.02051 21.665 3.03027 21.7656 3.0498C21.8662 3.07031 21.9639 3.09961 22.0586 3.13867C22.1533 3.17773 22.2432 3.22656 22.3281 3.2832C22.4131 3.33984 22.4922 3.40527 22.5645 3.47754C22.6367 3.5498 22.7021 3.62891 22.7588 3.71387C22.8154 3.7998 22.8633 3.88965 22.9023 3.98438C22.9424 4.0791 22.9717 4.17676 22.9912 4.27734C23.0117 4.37793 23.0215 4.47949 23.0215 4.58203Z",
    fill: "#A00000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1602_5662",
    x1: 21.4609,
    y1: 0.132703,
    x2: 21.4609,
    y2: 14.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#EE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#EE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#ED0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#E90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#E30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#E00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#E00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#DF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#DE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#DE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#DD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#DB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#DB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#D90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#D80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#D70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#D70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#D60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#D50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#D30000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D20000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#CF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#CE0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#CD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#CC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#CB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#CA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C80000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapicon);
export default __webpack_public_path__ + "static/media/mapicon.4b3430fbf1843e33fa5d465d696344f7.svg";
export { ForwardRef as ReactComponent };